<template>
  <div class="registerform">
    <h1>Register</h1>
    <form  @submit.prevent="register">
      <label for="username">
        <p>Email</p>
        <input type="text" id="username" ref="username" name="username" v-model="input.username" />
      </label>
      <div class="alert" v-if="this.formError && this.formErrorEmail">{{this.formErrorEmail}}</div>
      <label for="password">
        <p>Password</p>
        <input type="password" ref="password" name="password" v-model="input.password" />
      </label>
      <div class="alert" v-if="this.formError && this.formErrorPassword">{{formErrorPassword}}</div>
      <label for="password_confirmation">
        <p>Repeat Password</p>
        <input type="password" ref="password_confirmation" name="password_confirmation" v-model="input.password2" />
      </label>
      <button type="submit">Register</button>
    </form>
    <p>Have an account? <router-link to="/login"><a>Login</a></router-link></p>
  </div>
</template>

<script>
import {store} from '@/store'

export default {
  name: 'Register',
  data () {
    return {
      input: {
        username: '',
        password: '',
        password2: ''
      },
      errorMessage: 'Registration Error - it is possible that email address is in use',
      formError: false,
      formErrorEmail: false,
      formErrorPassword: false
    }
  },
  methods: {
    register () {
      if (this.input.username === '') {
        alert('email is necessary')
        this.$refs.username.focus()
      } else if (this.input.password === '') {
        alert('password is required')
      } else if (this.input.password !== this.input.password2) {
        alert('passwords must match')
      } else {
        let params = {'name': this.input.username, 'email': this.input.username, 'password': this.input.password, 'password_confirmation': this.input.password2}
        let $this = this
        this.$axios.get(process.env.API_BASE)
        this.$axios.post(process.env.API_BASE + 'api/register', params)
          .then(
            (response) => {
              let { data } = response
              let apiToken = data.data['api_token']
              store.commit('updateKey', {
                key: apiToken
              })
              $this.$cookie.set('key', apiToken, 30)
              $this.formError = false
              this.$router.push('/')
            },
            (error) => {
              $this.formError = true
              if (error.response.data.errors && error.response.data.errors.email) {
                $this.formErrorEmail = error.response.data.errors.email[0]
              }
              if (error.response.data.errors && error.response.data.errors.password) {
                $this.formErrorPassword = error.response.data.errors.password[0]
              }
            }
          )
      }
    }
  },
  mounted () {
    if (this.$parent.key) {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>

label {
  display: block;
  margin: 10px auto;
  max-width: 300px;
}
label p {
  margin-bottom: 0;
  text-align: left;
  font-size: 1.2rem;
}
label input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/auth/Register.vue